import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Navbar, Nav, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { applicationSetting, updateTheme } from '../../../redux/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUser, faUserCircle, faPalette } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import strings from '../../../globalization';


//Element start with capital
import Logout from './Logout'

//helper
import utility from '../../../utility';

class HeaderComponent extends PureComponent {
  onHamburgerClick = () => {
    this.props.dispatch(applicationSetting({ navOpen: !this.props.settingData.navOpen }));
  }
  onThemeChange = () => {
    const { loginData, dispatch, settingData } = this.props;
    const { isDark } = settingData;
    const { User } = loginData.userDetail || {};
    utility.applicationBody(!isDark);
    dispatch(applicationSetting({ isDark: !isDark }));
    dispatch(updateTheme({ action: 'update', _id: User, PreferredTheme: !isDark ? 'dark' : 'light' }));
  };

  render = () => {
    const { loginData, settingData } = this.props;
    const { isDark } = settingData;
    const { userDetail } = loginData || {};
    return (
      <Navbar color="light" light className={classNames('navbar shadow-sm p-3 mb-4 bg-theme rounded', { 'bg-theme-dark': isDark })} expand="md">
        <FontAwesomeIcon onClick={this.onHamburgerClick} icon={faBars} className={classNames('mr-2 barIcon', { 'headerIcon-dark': isDark })} />
        <img src="./img/logo.png" className="ml-auto" alt='' />
        <Nav className="ml-auto" navbar>
          <UncontrolledDropdown inNavbar className="mr-2" >
            <DropdownToggle nav caret>
              <FontAwesomeIcon size="lg" icon={faUserCircle} className={classNames('mr-2 user-profile-icon', { 'user-profile-icon-dark': isDark })} />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem header className="user-profile-details">
                <FontAwesomeIcon size="lg" icon={faUser} className="mr-2" /> {userDetail ? `${userDetail.LastName}, ${userDetail.FirstName}` : ''}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={this.onThemeChange}>
                <FontAwesomeIcon size="lg" icon={faPalette} className="mr-2" />{isDark ? strings.LightTheme : strings.DarkTheme}
              </DropdownItem>
              <DropdownItem divider />
              <Logout />
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Navbar>
    )
  }
}
const mapStateToProps = state => ({
  loginData: state.loginData.data,
  settingData: state.settingData
});

export default connect(mapStateToProps)(HeaderComponent);
